module.exports = __webpack_public_path__ + "img/button_double_chevron_right.81352bdb.svg";